// extracted by mini-css-extract-plugin
var _1 = "rqVicqIVozN_fP79KxoX";
export { _1 as "container" }
